const estabelecimento = {
    state: () => (
        {
            lojas: [],
            lojaSelecionada: {
              cod_rede: -1,
              cod_filial: -1,
              num_cnpj: 0,
              nome_filial: ''}
          }),
        getters: {
            getCodigoLojaSenior: (state) => state.lojaSelecionada.cod_filial,
            getCodigoRede: (state) => state.lojaSelecionada.cod_rede,
            getCnpj: (state) => state.lojaSelecionada.num_cnpj,
            getLojas: (state) => state.estabelecimentos,
            getNomeFilial: (state) => state.lojaSelecionada.nome_filial
        },
        mutations: {
          defineLojaSelecionada(state, dados){
            state.lojaSelecionada = dados
          },
          defineLojasUsuario(state, dados){
            state.lojas = dados
          },
          limpaEstabelecimentos(state){
            state.lojas = []
            state.lojaSelecionada = {
              cod_rede: -1,
              cod_filial: -1,
              num_cnpj: 0,
              nome_filial: ''
            }
          }
        },
        actions: {
        },
        modules: {
        },
  }

  export default estabelecimento